var allCount = 0;
var curCount = 0;
var needUpdate = false;
var handleCount = {};
var updateObj = {};
/*
var minItems = {
	//"be11450": 20,
	//"9900190": 40
};

var maxItems = {
	"9900190": 10
};
*/
var freeHandle = 'free-items';
var nextNumber = 0;
var g_freeSkuMap = {};

// count in cart...
var g_freeHandleCount = {};

var freeByHandle = {
//	"BE29150": {"buy":10, "get":5},
//	"BE29450": {"buy":10, "get":5},
//	"BE29350": {"buy":10, "get":5},
//	"BE11450": {"buy":10, "get":5},
//	"BE1020": {"buy":4, "get":1},
	"INSTANT-ICE-PACK": {"buy":4, "get":1},
	"FACIAL-TISSUE": {"buy":4, "get":1},
	"992734": {"buy":60, "get":1, "sku": "992729"},
	"992736": {"buy":50, "get":1, "sku": "992729"},

	"CODE-HERE":{"buy":10, "get":5}
};

//var g_freeByCost = [{
//	"amount": 299900,
//	"handle": ["9950960", "9951060", "9950670", "995080", "9950830", "9955600", "9954960", "9954560", "9936860", "9954890"],
//	"sku": "995155",
//	"get": 1,
//	"cost": 0
//}];

// free items need update  
var g_freeItems = {}; // "SKU" : {"count":X, "vid":"XXXX"}

function checkProductList() {
	g_freeSkuMap = {};
	getNextFreeProductList();
}

function getNextFreeProductList() {
	jQuery.getJSON('/products/' + freeHandle + '-' + nextNumber + '.js', onGetFreeObjects)
		.fail(onGetFreeObjectFail);
	nextNumber++;
}

function onGetFreeObjects(product) {
	for (var i = 0; i < product.variants.length; i++) {
		var variant = product.variants[i];
		//////////////////////////////////////////////////////
		// specail for 995156
		if (variant.sku == '995156' && variant.price == 19900) {
			discount995156_vid = variant.id;
			continue;
		}
		//////////////////////////////////////////////////////
		g_freeSkuMap[variant.sku] = variant.id;
	}
	getNextFreeProductList();
}

function onGetFreeObjectFail() {
	jQuery.getJSON('/cart.js', onGetCartObj);
}

function onGetCartObj(cart) {
	updateObj = {"updates":{}};

	handleCount = {};
	g_freeHandleCount = {};
	g_freeHandleCount.count = 0;
	dmpItemCount = {};
	needUpdate = false;

	initData(cart);
	//alert(JSON.stringify(handleCount));
	var handles = Object.keys(handleCount);
	allCount = handles.length;
	curCount = 0;
	for (var i = 0; i < allCount; i++) {
		jQuery.getJSON('/products/' + handles[i] + '.js', onGetProduct);
	}
	if (allCount == 0) {
		onCheckEnd();
	}
}

/*
function checkFreeByCost(itm) {
	for (var i = 0; i < g_freeByCost.length; i++) {
		var freeCostItem = g_freeByCost[i];
		for (var j = 0; j < freeCostItem.handle.length; j++) {
			if (freeCostItem.handle[j] == itm.handle) {
				freeCostItem.cost += itm.line_price;
				break;
			}
		}
	}
}//*/

function initData(cart) {
	
	allCount = cart.items.length;
	for (var i = 0; i < allCount; i++) {
		var itm = cart.items[i];
		var handle = itm.handle;
		var sku = itm.sku;
		var qua = parseInt(itm.quantity);
		updateObj.updates[itm.variant_id] = 0;
		
		if (handle.startsWith(freeHandle)) {
			if (g_freeSkuMap[sku] != undefined){
				g_freeHandleCount[sku] = qua;
				g_freeHandleCount.count += qua;
			}
			else {
				needUpdate = true;
			}
			continue;
		}

		//checkFreeByCost(itm);
		
		if (handleCount[handle] == undefined) {
			handleCount[handle] = {};
			handleCount[handle].count = 0;
			handleCount[handle].free_count = 0;
			handleCount[handle].sku = {};
		}
		if (handleCount[handle].sku[sku] == undefined) {
			handleCount[handle].sku[sku] = {};
			handleCount[handle].sku[sku].count = 0
			handleCount[handle].sku[sku].free_count = 0;
			handleCount[handle].sku[sku].vid = itm.variant_id;
		}


		handleCount[handle].count += qua;
		handleCount[handle].sku[sku].count += qua;
		if (handleCount[handle].sku[sku].vid != itm.variant_id) {
			handleCount[handle].sku[sku].vid = ' - - - - - - - ';
		}
	}
}

function checkAndCreateFreeHandleCount(sku) {
	if (g_freeHandleCount[sku] == undefined) {
		g_freeHandleCount[sku] = 0;
	}
}
function checkAndCreateFreeItems(sku) {
	if (g_freeItems[sku] == undefined) {
		g_freeItems[sku] = {};
		g_freeItems[sku].count = 0;
	}
}

function onGetProduct(product) {
    var handle = product.handle;
    var variants = product.variants;
    var data = handleCount[handle];

/*	
	// check min items
	if (minItems[handle] != undefined) {
		if (data.count < minItems[handle]){
			needUpdate = true;
			var skus = Object.keys(data.sku);
			data.sku[skus[0]].count += minItems[handle] - data.count;
			data.count = minItems[handle];
		}
		curCount++;
	    if (curCount >= allCount) {
			onCheckEnd();
		}
		return;
	}//*/

/*
	// check max items
	if (maxItems[handle] != undefined) {
		if (data.count > maxItems[handle]){
			needUpdate = true;
			var skus = Object.keys(data.sku);
			data.sku[skus[0]].count += maxItems[handle] - data.count;
			data.count = maxItems[handle];
		}
		curCount++;
	    if (curCount >= allCount) {
			onCheckEnd();
		}
		return;
	}//*/

/*
	// Check cost for free
	for (var i = 0; i < g_freeByCost.length; i++) {
		var freeCostItem = g_freeByCost[i];
		if (freeCostItem.cost >= freeCostItem.amount) {
			var sku = freeCostItem.sku;
			checkAndCreateFreeHandleCount(sku);
			checkAndCreateFreeItems(sku);

			if (g_freeHandleCount[sku] >= freeCostItem.get) {
				g_freeItems[sku].count += freeCostItem.get;
				g_freeHandleCount[sku] -= freeCostItem.get;
				g_freeHandleCount.count -= freeCostItem.get;
			}
			else {
				needUpdate = true;
				var tcount = g_freeHandleCount[sku];
				g_freeItems[sku].count += freeCostItem.get;
				g_freeHandleCount[sku] = 0;
				g_freeHandleCount.count -= tcount;
			}
		}
	}//*/

	// Check Buy X Get Y items
	var bxgy = freeByHandle[handle.toUpperCase()];
	if (undefined != bxgy) {

		var freeCount = Math.floor(data.count/bxgy.buy) * bxgy.get;

		if (bxgy.sku == undefined) { // not get by SKU.

			var k = Object.keys(data.sku);
			for (var i = 0; i < k.length; i++) {
				var sku = k[i];
				if (undefined != g_freeHandleCount[sku]) {
					checkAndCreateFreeItems(sku);
					data.sku[sku].free_count = g_freeHandleCount[sku];
					data.free_count += g_freeHandleCount[sku];

					g_freeItems[sku].count = g_freeHandleCount[sku];
					g_freeHandleCount.count -= g_freeHandleCount[sku];
				}
			}
			
			if (data.free_count != freeCount) {
				needUpdate = true;
				var countAdj = data.free_count - freeCount;
				for (var i = 0; i < k.length; i++) {
					var sku = k[i];
					checkAndCreateFreeItems(sku);
					var skuObj = data.sku[sku];
					if (skuObj.free_count >= countAdj) {
						skuObj.free_count -= countAdj;
						g_freeItems[sku].count -= countAdj;
						break;
					}
					else {
						countAdj -= skuObj.free_count;
						skuObj.free_count = 0;
						g_freeItems[sku].count = 0;
					}
				}
			}
		}
		else { // get free item SKU.
			var sku = bxgy.sku;
			checkAndCreateFreeHandleCount(sku);
			checkAndCreateFreeItems(sku);

			if (g_freeHandleCount[sku] >= freeCount) {
				g_freeItems[sku].count += freeCount;
				g_freeHandleCount[sku].count -= freeCount;
				g_freeHandleCount.count -= freeCount;
			}
			else {
				var tcount = g_freeHandleCount[sku].count;
				needUpdate = true;
				g_freeItems[sku].count += freeCount;
				g_freeHandleCount[sku].count = 0;
				g_freeHandleCount.count -= tcount;
			}
		}
	}
/*	else {
		// check is price quantity match
		for (var i = 0; i < variants.length; i++) {
			var variant = variants[i];
			var skuObj = data.sku[variant.sku];
			if (undefined == skuObj) {
				continue;
			}
			if (undefined == skuObj.vid || '' == skuObj.vid) {
				skuObj.vid = variant.id;
			}
			else if (skuObj.vid != variant.id) {
				skuObj.vid = variant.id;
				needUpdate = true;
			}
		}
	}*/
	
	curCount++;
    if (curCount >= allCount) {
		onCheckEnd();
	}
	//alert(JSON.stringify(data) + " . " + JSON.stringify(variants));
}

function onCheckEnd() {
	
	if (needUpdate || g_freeHandleCount.count > 0) {
		doUpdate();
	}
	else {
		div_page_waiting.style.display = "none";
	}
}

function doUpdate() {
	var handles = Object.keys(handleCount);
    for (var i = 0; i < handles.length; i++) {
		var skuData = handleCount[handles[i]].sku;
		for(var sku in skuData){
			var vid = skuData[sku].vid;
			if (vid == undefined || vid == '' || vid == ' ') {
				continue;
			}
			updateObj.updates[vid] = skuData[sku].count;
		}
	}
	var skuData = Object.keys(g_freeItems);
	for (var i = 0; i < skuData.length; i++) {
		var sku = skuData[i];
		var fvid = g_freeSkuMap[sku];
		if (fvid == undefined) {
			if (sku.substr(0, 1) == '#') {
				var nsku = sku.substr(1);
			}
			else {
				var nsku = '#' + sku;
			}
			fvid = g_freeSkuMap[nsku];
		}
		if (fvid == undefined || fvid == '' || fvid == ' ') {
			continue;
		}
		if (updateObj.updates[fvid] == undefined) {
			updateObj.updates[fvid] = g_freeItems[sku].count;
		}
		else {
			updateObj.updates[fvid] += g_freeItems[sku].count;
		}
	}

	//alert(JSON.stringify(updateObj));
	jQuery.post('/cart/update.js', updateObj, function() {
		document.location = '/cart';
	}, 'json');
}

$(document).ready(function(){
	checkProductList();
});
